import { useCallback } from "react";

import { usePreviewContext } from "../contexts/preview-context";
import { useAppContext } from "./useAppContext";
import { useIsPreviewMode } from "./useIsPreviewMode";
import { useKeyDown } from "./useKeyboard";

/**
 * Navigates between spreads with ArrowLeft/ArrowRight while preview mode is active.
 */
export function useArrowKeyPreviewNavigation() {
	const { goToPrev, goToNext } = usePreviewContext();
	const { googleAnalytics } = useAppContext();
	const [isPreviewMode] = useIsPreviewMode();

	useKeyDown(
		useCallback(
			(event: KeyboardEvent) => {
				if (!isPreviewMode) return;
				if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;

				event.stopPropagation();
				event.preventDefault();

				if (event.key === "ArrowLeft") {
					if (goToPrev()) {
						googleAnalytics.trackEventToGa({
							trackingAction: "PrevSpreadClicked",
						});
					}
					return;
				}

				if (goToNext()) {
					googleAnalytics.trackEventToGa({
						trackingAction: "NextSpreadClicked",
					});
				}
			},
			[goToNext, goToPrev, googleAnalytics, isPreviewMode],
		),
	);
}
